 import React,{useState,useEffect, useCallback} from "react"
 import DatePicker from 'react-datepicker'
 import DynamicSelectPost from './DynamicSelectPost'
 import DynamicSelect from './DynamicSelect'
 import AxiosFetchData from "../pages/AxiosFetchData"
 import { useNavigate } from "react-router-dom"
 //import UploadFile from './Upload'
 import UploadFiles from './UploadFiles'
 import Bindcomponent from "../utils/bindcomponent"
 import Helper from "../pages/Helper"
 
 const Payment = ({customer, setmessage,close=null,bind=null,data=null,action}) => {
    const navigate = useNavigate();
    const [payment,setPayment] = useState({
        customer :'',
        customer_id :'',
        amount : 0,
        ref_number : '',
        description :'',
        payment_date : Date.now(),
     })

    const [selectedOptPaymentMethod,setSelectedOptPaymentMethod] = useState({})
    const [selectedOptInvoices,setSelectedOptInvoices] = useState({})
    const [imageopen,setimageopen] = useState(false)
    const [randomId,setRandomId] = useState('')

    const BindData = useCallback( () => {
        if(data && action == "EDIT"){
         setPayment({customer:data.name, customer_id:data.customer_id})
         setPayment((prev) => ({...prev,
            amount : data.amount,
            ref_number : data.ref_no,
            description :data.note,
            payment_date :  Helper.DateDDMMYYYYtoYYYYMMDD(data.payment_date),

         }))
         setSelectedOptInvoices(data.invoice_id)
         setSelectedOptPaymentMethod(data.payment_method_id)
        }

        if(action == "ADD"){
          setPayment({customer:customer.label, customer_id:customer.value})
          setPayment((prev) => ({...prev,
            amount : 0,
            ref_number : '',
            description :'',
            payment_date : Date.now(),
 
          }))

          setSelectedOptInvoices({})
          setSelectedOptPaymentMethod({})
          let imageId = "temp-" + Math.random().toString().substring(2)
          setRandomId(imageId)
        }
    },[customer,action])

    useEffect(()=>{
        BindData();
         
    },[BindData])

    

    const handleSubmit = async (e) =>{
      e.preventDefault();
      try{
        let paymentData ={
          amount : payment.amount,
          customer_id:payment.customer_id,
          invoice_id : action == "EDIT" ? selectedOptInvoices : selectedOptInvoices.value,
          payment_method_id : selectedOptPaymentMethod.value,
          note : payment.description,
          payment_date : payment.payment_date,
          ref_no : payment.ref_number,
          imageId : randomId
        }
    // / console.log(selectedOptInvoices)
        let response;
        if(action == "EDIT"){
            delete paymentData.imageId
            paymentData.payment_code = data.payment_code
           
            response = await AxiosFetchData.post(`updatePayment`, paymentData).refreshToken(navigate,"payment");
        }else{
            response = await AxiosFetchData.post(`createPayment`, paymentData).refreshToken(navigate,"payment");
        }

        if(response){
          if(response.data == "true"){
            setmessage("Payment amount is more then total invoice amount")
          }else{
            setmessage(response.data)
          }
          
          if(close != null){
            close(false)
          }

          if(bind != null)
          { 
            bind();
          }
        }
      }catch(err){
        console.log(err)
        setmessage(err.message)
      }
    }
 
    const handleUploadDialogClose = useCallback(async () =>{
        setimageopen(false)
    },[])

    return (
        <>
      
    <div class="row justify-content-center">
      <div class="col-md-12 bg-white p-4 rounded shadow-sm">
       
        <form onSubmit={handleSubmit}>
      
          <div class="mb-3">
            <label for="name" class="form-label">Customer</label>
            <input type="text" class="form-control" id="name" placeholder="Enter Customer"  value={payment.customer} onChange={(e) => setPayment({...payment,customer:e.target.value})} readOnly={true} required/>
          </div>
          <div class="mb-3">
            <label for="name" class="form-label">Invoices</label>
            <Bindcomponent component='DynamicSelect' url={"GetPaymentInvoices/" + payment.customer_id} label={"{kode}"} value="id" id="optInvMethod" selectedvalue={selectedOptInvoices} onChange={(opt) => setSelectedOptInvoices(opt)} required></Bindcomponent>  
            {/* <DynamicSelect url={"GetPaymentInvoices/" + payment.customer_id} label={"{kode}"} value="id" id="optInvMethod" selectedvalue={selectedOptInvoices} onChange={(opt) => setSelectedOptInvoices(opt)} required></DynamicSelect> */}
          </div>
          <div class="mb-3">
            <label for="name" class="form-label">Amount</label>
            <input type="text" class="form-control" id="name" placeholder="Enter Amount" value={payment.amount} onChange={(e) => setPayment({...payment,amount:e.target.value})} required/>
          </div>
          <div class="mb-3">
            <label for="paymentmethod" class="form-label">Payment Method</label>
            {/* <input type="text" class="form-control" id="paymentmethod" placeholder="Enter Payment Method" value={payment.payment_method} onChange={(e) => setPayment({payment_method:e.target.value})}/> */}
             <Bindcomponent component='DynamicSelectPost' url="Entity/paymentmethod" label={"{id} - {name}"} value="id" id="optPaymentMethod" selectedvalue={selectedOptPaymentMethod} onChange={(opt) => setSelectedOptPaymentMethod(opt)} required></Bindcomponent>  
            {/* <DynamicSelectPost url="Entity/paymentmethod" label={"{id} - {name}"} value="id" id="optPaymentMethod" selectedvalue={selectedOptPaymentMethod} onChange={(opt) => setSelectedOptPaymentMethod(opt)} required></DynamicSelectPost> */}
          </div>

          <div class="mb-3">
            <label for="refnumber" class="form-label">Ref Number</label>
            <input type="text" class="form-control" id="refnumber" placeholder="Enter Ref Number" value={payment.ref_number} onChange={(e) => setPayment({...payment,ref_number:e.target.value})} />
          </div>
          
          <div class="mb-3">
            <label for="paymentmethod" class="form-label">Payment Date{payment.payment_date}</label><br></br>
            <DatePicker 
                showIcon
               // selected={new Date(Helper.GetDateYYYYMMDD((payment.payment_date)).replaceAll('/','-'))}
                  selected={new Date(payment.payment_date)}
                onChange={(date) => setPayment({...payment,payment_date:date})}
                dateFormat="dd-MM-yyyy"
                className="form-control"
                required
                 />
          </div>
          <div class="mb-3">
            <label for="desc" class="form-label">Note</label>
            <input type="text" class="form-control" id="desc" placeholder="Enter Note" value={payment.description} onChange={(e) => setPayment({...payment,description:e.target.value})}/>
          </div>
          <div class="mb-3">
            <label for="desc" class="form-label">Upload / View Files</label><br></br>
            <button type="button" class="btn btn-primary w-100" onClick={(e) => setimageopen(true)}>image/document</button>
          </div>
         
        <div style={{textAlign:"right", marginTop:30}}>
          <hr></hr>
            <button type="submit" class="btn btn-primary w-100">{action == "ADD" ? "ADD PAYMENT" :"UPDATE PAYMENT"}</button>
        </div>
        
        </form>
      </div>
    </div>
      <Bindcomponent component='UploadFiles' productopen={imageopen} handleClose={handleUploadDialogClose}  id={action=="EDIT" ? data.payment_code : randomId} navigate={navigate} table="payment" type="payment"></Bindcomponent>   
      {/* <UploadFiles productopen={imageopen} handleClose={handleUploadDialogClose}  id={action=="EDIT" ? data.payment_code : randomId} navigate={navigate} table="payment" type="payment"></UploadFiles>   */}
        </>
    )
}

export default React.memo(Payment)